"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _BorderedTextBox = _interopRequireDefault(require("../common/BorderedTextBox"));
var _Subtitle = _interopRequireDefault(require("../common/Subtitle"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var Errors = function Errors(_ref) {
  var actionPlans = _ref.actionPlans;
  return actionPlans === null || actionPlans === void 0 ? void 0 : actionPlans.filter(function (ap) {
    return ap.error;
  }).map(function (actionPlan, index) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Subtitle.default, {
        children: "We weren't sure how to address this issue."
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_BorderedTextBox.default, {
        children: actionPlan.error
      })]
    }, index);
  });
};
var _default = exports.default = Errors;